import { render } from "./ParticlesJS.vue?vue&type=template&id=5e381b31"
import script from "./ParticlesJS.vue?vue&type=script&lang=js"
export * from "./ParticlesJS.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__